import React from 'react';
import { useT } from '../../../i18n';

const InsideRegion = React.createContext(false);

interface IProps {
  className?: string;
  style?: React.CSSProperties;
  label?: string;
  children: React.ReactNode;
}

/**
 * Wraps a group of placeholders in a single live region. Nested skeletons
 * render as plain containers so a screen reader announces "loading" once per
 * screen instead of once per block.
 */
const SkeletonRegion: React.FC<IProps> = ({ className, style, label, children }) => {
  const nested = React.useContext(InsideRegion);
  const t = useT();

  if (nested) {
    return (
      <div className={className} style={style}>
        {children}
      </div>
    );
  }

  return (
    <InsideRegion.Provider value>
      <div
        className={className}
        style={style}
        role="status"
        aria-busy="true"
        aria-label={label ?? t('x.loading')}
      >
        {children}
      </div>
    </InsideRegion.Provider>
  );
};

export default SkeletonRegion;
